import React from 'react';
import {
  Button,
  GridCol,
  GridRow,
  Heading,
  Modal,
  ModalBody,
  ModalFooter
} from '@lmig/lmds-react';

export interface IActionModalProp {
  isOpen: boolean,
  setIsOpen: (value: boolean) => void,
  action: () => void,
  title: string,
  cancelLabel?: string,
  actionLabel?: string,
  loading?: boolean
}

const ActionModal = ({
  isOpen,
  setIsOpen,
  action,
  title,
  cancelLabel = 'Cancel',
  actionLabel = 'Proceed',
  loading = false
}: IActionModalProp): JSX.Element => {

  return (
    <>
      <Modal mandatory={loading} isOpen={isOpen} onClose={() => setIsOpen(false)} size="small">
        <ModalBody>
          <Heading tag="span" type="h3-light">
            {title}
          </Heading>
        </ModalBody>

        <ModalFooter>
          <GridRow gutterSize="fixed-16" gutters>
            <GridCol base={12} md={6}>
              <Button disabled={loading} dynamicWidth onClick={() => setIsOpen(false)}>
                {cancelLabel}
              </Button>
            </GridCol>

            <GridCol base={12} md={6}>
              <Button variant="primary" loading={loading} onClick={() => action()}>
                {actionLabel}
              </Button>
            </GridCol>
          </GridRow>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default ActionModal;
